import { Sidebar } from "@/components/styleguide/Sidebar";
import { NAV_ITEMS } from "@/data/navItems";
import { HeroSection } from "@/components/styleguide/sections/HeroSection";
import { ColorSection } from "@/components/styleguide/sections/ColorSection";
import { TypographySection } from "@/components/styleguide/sections/TypographySection";
import { SpacingSection } from "@/components/styleguide/sections/SpacingSection";
import { RadiusSection } from "@/components/styleguide/sections/RadiusSection";
import { ElevationSection } from "@/components/styleguide/sections/ElevationSection";
import { IllustrationSection } from "@/components/styleguide/sections/IllustrationSection";
import { IconSection } from "@/components/styleguide/sections/IconSection";
import { MotionSection } from "@/components/styleguide/sections/MotionSection";
import { ComponentsSection } from "@/components/styleguide/sections/ComponentsSection";
import { AccessibilitySection } from "@/components/styleguide/sections/AccessibilitySection";
import { ResponsiveSection } from "@/components/styleguide/sections/ResponsiveSection";
import { FooterSection } from "@/components/styleguide/sections/FooterSection";

export default function FoundationsPage() {
  return (
    <div className="App min-h-screen overflow-x-clip bg-background text-foreground antialiased">
      <Sidebar items={NAV_ITEMS} subtitle="Foundations" />
      <main className="lg:pl-72">
        <HeroSection />
        <div className="mx-auto w-full max-w-content px-5 sm:px-8 lg:px-12">
          <ColorSection />
          <TypographySection />
          <SpacingSection />
          <RadiusSection />
          <ElevationSection />
          <IllustrationSection />
          <IconSection />
          <MotionSection />
          <ComponentsSection />
          <AccessibilitySection />
          <ResponsiveSection />
        </div>
        <FooterSection />
      </main>
    </div>
  );
}
